export enum ExpressionType {
  'NULL' = 'null',
  'BINARY' = 'binary',
  'VARIADIC' = 'variadic',
  'UNARY' = 'unary',
}

export enum HQLOperator {
  'AND' = 'AND',
  'CONTAINS' = 'CONTAINS',
  'DOES_NOT_CONTAIN' = 'DOES NOT CONTAIN',
  'DOES_NOT_EQUAL' = 'DOES NOT EQUAL',
  'EQUALS' = 'EQUALS',
  'GREATER_THAN' = 'GREATER THAN',
  'NEVER_OCCURRED' = 'NEVER OCCURRED',
  'NULL' = 'NULL',
  'OCCURED_AFTER' = 'OCCURED AFTER',
  'OCCURRED_AFTER_RELATIVE' = 'OCCURRED AFTER RELATIVE',
  'OCCURRED_BEFORE_RELATIVE' = 'OCCURRED BEFORE RELATIVE',
  'OCCURRED_BEFORE' = 'OCCURRED BEFORE',
  'OCCURRED_IN_YEAR' = 'OCCURRED IN year',
  'OCCURRED_ON_DAY' = 'OCCURRED ON DAY',
  'OCCURRED_ON' = 'OCCURRED ON',
  'OCCURRED' = 'OCCURRED',
  'OR' = 'OR',
  'STARTS_WITH' = 'STARTS WITH',
}
